import ProtoBufApi from '@/services/protobuf-api'

export default {
  async getLicenceData() {
    var protoDefinition = require('../../assets/proto/LicenseDataModel.proto')
    var message = protoDefinition.Access.LicenseDataModel
    const result = await ProtoBufApi.get('/access/licensedata')
    const rs = message.decode(new Uint8Array(result.data))
    return rs
  }
}
